import { combineRules } from 'fela';

import type { TRuleWithTheme } from '@/styles/theme';

import { sortIconClassNames } from './SortIcon/constants';

export const container: TRuleWithTheme = ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
});

export const table: TRuleWithTheme = ({ theme }) => ({
    '--ant-table-border-color': theme.colors.borderCards,

    '& table': {
        borderColor: theme.colors.borderCards,
        borderRadius: '0.25rem',
        borderWidth: '1px',
        borderStyle: 'solid',
    },

    // Antd styles the cells through `.ant-table-thead > tr > th`, which outranks a single class
    // on the cell itself — hence the descendant selectors rather than `tableHeaderCell`/`tableCell`.
    '& .ant-table-thead > tr > th': {
        ...theme.typography.ParagraphSmallBold,
        color: theme.colors.foregroundsPrimary,
    },

    '& .ant-table-tbody > tr > td': {
        ...theme.typography.ParagraphSmallMedium,
        color: theme.colors.foregroundsPrimary,
    },
});

export const checkbox: TRuleWithTheme = ({ theme }) => ({
    '& .ant-checkbox-inner': {
        '--ant-color-border': theme.colors.tabsEnabled,
    },

    '& .ant-checkbox-checked .ant-checkbox-indeterminate, .ant-checkbox-inner': {
        '--ant-color-primary': theme.colors.accentSecondary,
        '--ant-color-primary-hover': theme.colors.accentSecondary,
    },

    '& .ant-checkbox-wrapper:not(.ant-checkbox-wrapper-disabled):hover .ant-checkbox-inner': {
        borderColor: theme.colors.accentSecondary,
    },
});

export const tableHeaderRow: TRuleWithTheme = combineRules(checkbox, ({ theme }) => ({
    '--ant-table-header-bg': theme.colors.backgroundsTertiary,
    '--ant-table-header-sort-active-bg': theme.colors.backgroundsTertiary,
    '--ant-table-header-sort-hover-bg': theme.colors.backgroundsTertiary,

    '--ant-table-header-split-color': 'transparent',
}));

export const tableHeaderCell: TRuleWithTheme = ({ theme }) => ({
    height: '4rem',
    verticalAlign: 'middle',

    '--ant-table-cell-padding-block': '11px',
    '--ant-table-cell-padding-inline': '0px',

    '& .ant-table-column-title': {
        flex: 'none',
    },

    '& .ant-table-column-sorters': {
        justifyContent: 'start',
        gap: '0.5rem',
    },

    [`:hover .${sortIconClassNames.sortIcon}:not(.${sortIconClassNames.sortIconActive})`]: {
        color: theme.colors.iconsSecondary,
    },
});

export const visibleOnRowHoverClassName = 'visible-on-row-hover';

export const tableRow: TRuleWithTheme = combineRules(checkbox, ({ theme }) => ({
    '--ant-table-row-hover-bg': theme.colors.backgroundsSelected,
    '--ant-table-row-selected-bg': theme.colors.backgroundsSelected,
    '--ant-table-row-selected-hover-bg': theme.colors.backgroundsSelected,

    '&:last-child td': {
        '--ant-table-border-color': 'transparent',
    },

    [`&:hover .${visibleOnRowHoverClassName}`]: {
        opacity: 1,
        visibility: 'visible',
    },
}));

export const tableCell: TRuleWithTheme = ({ theme }) => ({
    height: '2.5rem',
    verticalAlign: 'middle',

    '--ant-table-cell-padding-block': '11px',
    '--ant-table-cell-padding-inline': '0px',

    '--ant-table-body-sort-bg': 'transparent',
});
